import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
    name: "search",
    initialState: {
        response: null,
    },
    reducers:  {
        addSearchResults: (state, action) => {
            state.response = action.payload;
          },
    },
});

export const {addSearchResults} = searchSlice.actions;
export default searchSlice.reducer;

